/* ----------------------------------------
カスタムJS
---------------------------------------- */

/* 
  即時関数内で実行することにより、他のスクリプトに影響を与えない。
*/

// 即時関数
(function(){
  
  /**
   * loadScript
   * 
   * 外部cdnのライブラリを読み込み、callback関数を実行する
   * @param {String} url 読み込む外部ライブラリのcdnのurl
   * @param {Function} callback 読み込み完了後、実行する関数
   * @return {None} 
   */
  var loadScript = function(urls, callback){

    // 読み込むスクリプトファイルの場所
    url = urls[0];

    // 先頭行を削除
    urls.shift();

    // script要素の生成
    var script = document.createElement("script");
    script.type = "text/javascript";
    
    // 読み込み完了後のコールバック呼び出し実装
    if (script.readyState){   // ----- IE用処理
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;

          // urlsが残っていれば、再起呼び出しする。
          if(urls.length >= 1){
            loadScript(urls,callback);
          }else{
            callback();
          }
        }
      };
    } else {  // ----- IE以外のブラウザ用の処理
      script.onload = function(){

        // urlsが残っていれば、再起呼び出しする。
        if(urls.length >= 1){
          loadScript(urls,callback);
        }else{
          callback();
        }
      };
    }

    // script要素をページに組み込む
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };
  
  /**
   * myAppJavaScript
   * 
   * 外部ライブラリ読み込み後に適用するスクリプト
   * @param {Obj} $ jQueryオブジェクト
   * @return {None} 
   */
  var myAppJavaScript = function($){

    // スリックスライダー
    $('[data-js="slickSlide"]').slick({
      dots: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 749,
        settings: {
          centerMode: true,
          centerPadding: '20%',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }]
    });

    // するするスクロール
    $('a[href^="#"]').on('click',function(){

      let speed = 500;
      let href= $(this).attr("href");
      let target = $("href");
      //let target = $(href);

      if( !target.length ){
        return false;
      }

      // ヘッダの高さ取得
      let header_height = $('header').innerHeight();

      let position = target.offset().top - header_height - 20;

      $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });

    // 会員登録での規約同意処理
    if( $('body').hasClass('template-customers-register') ){

      // （１）規約に同意するチェックボックスを押した時の処理実装
      $('.cc-agree input').on('click',function(){

          if($(this).prop("checked")){  // OFF -> ON

              // 「作成する」ボタンを活性化する
              $('main input[type="submit"]').removeAttr('disabled');

          }else{  // ON -> OFF

              // 「作成する」ボタンを不活性化する
              $('main input[type="submit"]').attr('disabled','disabled');
          }
      });

      // （２）不活性「作成する」ボタンを押したときの処理
      $('[data-js="submitStopper"]').on('click',function(){
          alert('登録するには、規約に同意する必要があります。');
      })
    }

    // 商品詳細ページで、カートに追加ボタンを押したとき、バンドルにチェックをつける
    if( $('body').hasClass('template-product') ){

      // ボタンのクリック処理実装
      $('form[action="/cart/add"] [type="submit"]').not('[aria-disabled="true"]').on('click', function(){

        // チェックマークのソース
        let checkmark = '<div class="bold-bundles-widget-item__in_cart_identifier"><img class="checkmark" src="https://cdn.shopify.com/s/files/1/0516/1743/1714/files/checkmark2.png?v=1622770077"></div>';

        // タイトルから商品の種類を判別する
        let product_name = $('.product-template__container .product-single__meta .product-single__title').html();
        if( product_name && product_name.indexOf('大判') !== -1 ){  // 大判

          // チェックマークが無ければ追加する。
          let $target = $('.product-template__container .bold-bundles-widget__items .bold-bundles-widget-item--product').eq(0).find('.bold-bundles-widget-item__wrapper');
          if( !$target.find('.bold-bundles-widget-item__in_cart_identifier').length ){
            $target.prepend(checkmark);
          }
        }else if( product_name && product_name.indexOf('ミニサイズ') !== -1 ){

          // チェックマークが無ければ追加する。
          let $target = $('.product-template__container .bold-bundles-widget__items .bold-bundles-widget-item--product').eq(1).find('.bold-bundles-widget-item__wrapper');
          if( !$target.find('.bold-bundles-widget-item__in_cart_identifier').length ){
            $target.prepend(checkmark);
          }
          
        }else if( product_name && product_name.indexOf('卓上') !== -1 ){

          // チェックマークが無ければ追加する。
          let $target = $('.product-template__container .bold-bundles-widget__items .bold-bundles-widget-item--product').eq(2).find('.bold-bundles-widget-item__wrapper');
          if( !$target.find('.bold-bundles-widget-item__in_cart_identifier').length ){
            $target.prepend(checkmark);
          }

        }

      })
    }
    // 商品詳細画面のとき、スクロール追随カートボタンを実装する
    let initBottomFixedBtnCart = function(){

      // 本来のカートボタンの取得
      let $btnCart = $('form.product-form button[name="add"]');

      // a（１）スクロール位置に応じて、表示非表示させる
      $(window).on('load scroll resize', function(){

        // ドキュメント（コンテンツ）の全体の高さと、ウィンドウ下限位置の取得
        let documentHeight = $(document).height();
        let windowBottom = $(window).scrollTop() + $(window).height();

        if(
          $btnCart.offset().top + $btnCart.innerHeight() < $(window).scrollTop() && // 本来のカート追加ボタンが画面上にはずれるまでスクロールしたとき
          documentHeight > windowBottom + 10  // 最下部に来ていないとき（※10pxはバッファ）
        ){
          // 表示する
          $('.aaa_header_bar.header_11.text-center').addClass('-show');
          $('.ls-sw-bottom-right').addClass('-show');
          $('.bottomFixedBtnCart').addClass('-show');
        }else{
          // 隠す
          $('.aaa_header_bar.header_11.text-center').removeClass('-show');
          $('.ls-sw-bottom-right').removeClass('-show');
          $('.bottomFixedBtnCart').removeClass('-show');
        }



      })
      
      // （２）ボタンを押したときに、カート追加処理を行う
      $('.bottomFixedBtnCart a').on('click', function(e){
        e.preventDefault();

        // 本来のカート追加ボタンのクリックイベント発火
        $btnCart.click();
      })

    }
    if( $('body').hasClass('template-product') ){
      initBottomFixedBtnCart();
    }
    
    // コレクションリストページで、絞り込みを実装
    let initFilterInCollectionList = function(){

      // フィルターメニューをクリックしたら、絞り込む
      $('[js-filter]').on('click', function(e){

        e.preventDefault();

        // ボタンのアクティブを削除
        $(this).closest('ul').find('li').removeClass('-active');

        // 全てのアイテムをいったん非表示にする
        $('ul.collectionList li').hide();

        // ボタンのアクティブ付与
        $(this).closest('li').addClass('-active');

        // 表示するターゲットを取得
        let target = $(this).attr('filter_target');

        // ターゲットのみ表示
        $('ul.collectionList li' + '[filter_type="' + target + '"]').show();
      });
    }
    if( $('body').hasClass('template-list-collections') ){
      initFilterInCollectionList();
    }

    // 会員登録ページで、ペットの種類に「その他」をえらんだら、対応する入力フォームを表示する。
    let showOtherPetType = function(){

      $('[data-js-showother]').each(function(){

        // 対応する要素取得
        const for_value = $(this).attr('data-js-showother');
        let $target = $(`[for=${for_value}]`);

        // 値を変更したときの処理実装
        $(this).on('change', function(){
          console.log('変更されました！！');

          if( $(this).val() == 'その他' ){
            $target.removeClass('_hideThisAndNext');
          }else{
            $target.addClass('_hideThisAndNext');
          }
        })
      })

    }
    if( $('body').hasClass('template-customers-register') ){
      showOtherPetType();
    }

    // datepicker初期化ファンクション
    let initDatePicker = () => {
      if( $('[js-ui="datepicker"]') ){
        $('[js-ui="datepicker"]').datepicker({
          dateFormat: 'yy/mm/dd',
          changeMonth: true,
          changeYear: true,
          yearRange: '-100:+0',
        });
        console.log('init datepicker complete');
      }else{
        setTimeout(initDatePicker, 1000);
      }
    }
    initDatePicker();
  };

  // すべての外部ライブラリを読み込んで、最後に関数myAppJavaScriptを実行する
  loadScript(lib,function(){

    // $とjQueryを解放しつつ、関数myAppJavaScriptにjQueryオブジェクトを渡す
    jQueryLatest = jQuery.noConflict(true);
    myAppJavaScript(jQueryLatest);
  });

})();
